import React from 'react';
import MainSection from '../components/MainSection';

const Alumni: React.FC = () => {
    const data = {
        page: 'alumni'
    };
    return (
        <div id="page-wrapper">
            <MainSection page={data.page} />
        </div>
    );
};

export default Alumni;
